import PropTypes from 'prop-types';
import SceneToggleButton from './SceneToggleButton';

function QuickViewsToggle({
    toggle,
}) {
    return (
        <SceneToggleButton
            ariaLabel={toggle.ariaLabel}
            ariaPressed={toggle.ariaPressed}
            className={`scene-toggle quick-views ${toggle.active ? 'active' : ''}`}
            disabled={toggle.disabled}
            onClick={toggle.onClick}
            title={toggle.title}
        >
            <>
                <span className="scene-toggle-icon-shell">
                    <i className="material-icons icon" role="presentation">photo_camera</i>
                </span>
                <span>Quick Views</span>
            </>
        </SceneToggleButton>
    );
}

QuickViewsToggle.propTypes = {
    toggle: PropTypes.shape({
        active: PropTypes.bool.isRequired,
        ariaLabel: PropTypes.string.isRequired,
        ariaPressed: PropTypes.bool.isRequired,
        disabled: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default QuickViewsToggle;
